// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3rMjX","inner":"Footer_inner__249Rl","nextIcon":"Footer_nextIcon__P9ZBG","innerLeft":"Footer_innerLeft__3BM53"};